import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  templateUrl: './unauthorised.component.html'
})
export class UnauthorisedComponent {

  today = new Date();

  constructor(private location: Location, private router: Router) { }

  back() {
    this.location.back();
  }
  logOut() {
    localStorage.clear();
    this.router.navigateByUrl('/u/login');
  }

}
